import utils from '../../app/utils'

import './style.css';

export default class OurPropertiesListPage {
    static selector = '.op-list-page';

    constructor(block) {
        this.block = block;

        this.filtersToggler = this.block.querySelector('#toggle-filters');

        this.filtersToggler.addEventListener('click', () => {
            this.filtersToggler.classList.toggle('is-open')
            this.block.querySelector('.properties-filters__outer').classList.toggle('is-open');
        });

        this.sorter = this.block.querySelector('#order_by');

        this.sorter.addEventListener('change', (e) => {
            window.App
                .navigateTo(
                    `${window.location.pathname}${utils.prepareParamsForUrl(e.target.value, 'order_by', false)}`,
                    '#content',
                    '#content',
                    false,
                );
        })
    }
}
